import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Joi, { options } from '@hapi/joi';
import { NormAssignSchemaObject } from '../NormAssignSchema';
import { validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import tokenService from '../../../Common/tokenDecoder';
import { MultiSelect } from '../../../Common/multiSelect';
import { set } from 'lodash';

const screenCode = 'NORMASSIGN';

export function NormAddEdit(props) {
    const [groups, setGroups] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [estates, setEstates] = useState([]);
    const [configurationName, setConfigurationName] = useState([]);
    const [errors, setErrors] = useState({});
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisionEstateMap, setDivisionEstateMap] = useState({});
    const [filteredEstates, setFilteredEstates] = useState({});
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [isEnable, setIsEnable] = useState(true);
    const [selectedDivisions, setSelectedDivision] = useState([])
    const [selectedEstates, setSelectedEstates] = useState([]);
    const [normValue, setNormValue] = useState({
        groupID: '0',
        estate: '0',
        configurationID: '0',
        divisionID: [],
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        configurationValue: '',
        minValue: '',
        maxValue: '',
    });
    const [normDetails, setNormDetails] = useState([]);
    const schema = Joi.object(NormAssignSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(getPermissions());
        getAllGroups();
    }, []);

    useEffect(() => {
        if (normValue.groupID !== '0') {
            getEstatesForDropdown();
        }
    }, [normValue.groupID]);

    useEffect(() => {
        if (selectedEstates.length > 0) {
            getConfigurationNameForDropdown();
            getDivisionsForDropDown();
        } else {
            setDivisions({});
            setDivisionEstateMap({});
            setSelectedDivision([]);
            setNormValue(prev => ({
                ...prev,
                divisionID: []
            }));
        }
    }, [selectedEstates]);

    useEffect(() => {
        const selectedEstateIDs = new Set(selectedEstates.map(option => String(option.value)));

        const filteredDivisions = selectedDivisions.filter(option => {
            const relatedEstateID = option.estateID !== undefined
                ? String(option.estateID)
                : String(divisionEstateMap[option.value]);

            return selectedEstateIDs.has(relatedEstateID);
        });

        if (filteredDivisions.length !== selectedDivisions.length) {
            setSelectedDivision(filteredDivisions);
            setNormValue(prev => ({
                ...prev,
                divisionID: filteredDivisions.map(option => option.value)
            }));
            setErrors(prev => ({ ...prev, divisionID: undefined }));
        }
    }, [divisionEstateMap, selectedEstates]);

    const handleChange = (e) => {
        validateInputs(e.target);
        setNormValue({
            ...normValue,
            [e.target.name]: e.target.value
        });
    };

    const handleDivisionChange = (selectedOptions) => {
        setSelectedDivision(selectedOptions);
        setNormValue(prev => ({
            ...prev,
            divisionID: selectedOptions.map(option => option.value)
        }));
        setErrors(prev => ({ ...prev, divisionID: undefined }));
    };

    const handleDivisionSelectAll = (selectAll) => {
        if (selectAll) {
            const allOptions = Object.entries(divisions).map(([value, label]) => ({
                value,
                label,
                estateID: divisionEstateMap[value]
            }));
            setSelectedDivision(allOptions);
            setNormValue({
                ...normValue,
                divisionID: allOptions.map(option => option.value)
            });
        }
        else {
            setSelectedDivision([]);
            setNormValue({
                ...normValue,
                divisionID: []
            });
        }
        setErrors(prev => ({
            ...prev,
            divisionID: undefined
        }));
    }

    const handleDivisionClear = () => {
        setSelectedDivision([]);
        setNormValue({
            ...normValue,
            divisionID: []
        });
        setErrors(prev => ({
            ...prev,
            divisionID: undefined
        }));
    }

    function handleFromDateChange(target) {
        const newFromDate = target.value;
        const currentToDate = normValue.toDate;

        setNormValue(prevState => ({
            ...prevState,
            fromDate: newFromDate,
            toDate: new Date(currentToDate) < new Date(newFromDate) ? newFromDate : currentToDate
        }));
    }

    const handleToDateChange = (target) => {
        const toDate = new Date(target.value);
        const fromDate = new Date(normValue.fromDate);

        if (toDate < fromDate) {
            setErrors(prevErrors => ({
                ...prevErrors,
                toDate: 'To Date must be after From Date.'
            }));
        } else {
            setErrors(prevErrors => ({
                ...prevErrors,
                toDate: ''
            }));
            setNormValue(prevState => ({
                ...prevState,
                toDate: target.value
            }));
        }
    };

    const handleSundayToggle = (event) => {
        const enabled = event.target.checked;

        setNormValue(prev => ({
            ...prev,
            isSundayEnabled: enabled,
            minValue: '',
            maxValue: ''
        }));
        setNormDetails([]);
        setIsEnable(true);
        setIsTableHidden(true);
    };

    const handleAdd = (e) => {
        e.preventDefault();

        const errorMessages = validate(schema, normValue);
        setErrors(errorMessages || {});
        if (errorMessages && Object.keys(errorMessages).length > 0) {
            return;
        }

        const { minValue, maxValue } = normValue;
        if (parseFloat(minValue) > parseFloat(maxValue)) {
            setErrors({ minValue: "Min Value cannot be greater than Max Value." });
            return;
        }

        const startDate = new Date(normValue.fromDate);
        const endDate = new Date(normValue.toDate);
        const dateRange = [];

        // ✅ if no divisions selected, use ALL divisions from the divisionEstateMap
        const divisionsToUse = selectedDivisions.length > 0
            ? selectedDivisions
            : Object.entries(divisionEstateMap).map(([divID, estateID]) => ({
                value: divID,
                label: divisions[divID] || "Unknown Division",
                estateID: estateID
            }));

        if (divisionsToUse.length === 0) {
            setErrors(prev => ({ ...prev, divisionID: "No divisions available for the selected operation entities." }));
            return;
        }

        divisionsToUse.forEach(option => {
            const divisionID = option.value;
            const divisionLabel = option.label || divisions[divisionID] || "Unknown Division";
            const estateID = option.estateID || divisionEstateMap[divisionID];
            let currentDate = new Date(startDate);
            while (currentDate <= endDate) {
                const isSunday = currentDate.getDay() === 0;
                if (normValue.isSundayEnabled && !isSunday) {
                    currentDate.setDate(currentDate.getDate() + 1);
                    continue;
                }
                if (!normValue.isSundayEnabled && isSunday) {
                    currentDate.setDate(currentDate.getDate() + 1);
                    continue;
                }
                dateRange.push({
                    ...normValue,
                    fromDate: currentDate.toISOString().split('T')[0],
                    division: divisionLabel,
                    divisionID: divisionID,
                    estateID: estateID
                });
                currentDate.setDate(currentDate.getDate() + 1);
            }
        });

        if (dateRange.length === 0) {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: normValue.isSundayEnabled
                    ? "No Sundays found in the selected date range."
                    : "No valid dates found in the selected date range. The selected range may only contain Sundays."
            });
            setTimeout(() => {
                setMessageModel(prev => ({ ...prev, hidden: true }));
            }, 4000);
            return;
        }

        setNormDetails([...normDetails, ...dateRange]);
        setIsEnable(false);
        setIsTableHidden(false);
    };

    async function handleSave() {
        const selectedConfigName = Object.entries(configurationName)
            .find(([key]) => String(key) === String(normValue.configurationID))?.[1];

        const detail = normDetails.map(item => {
            const divisionID = parseInt(item.divisionID);
            const estateID = parseInt(item.estateID);
            return {
                groupID: parseInt(normValue.groupID),
                estateID: estateID,
                divisionID: divisionID,
                configurationName: selectedConfigName || '',
                fromDate: item.fromDate,
                toDate: item.fromDate,
                configurationValue: item.configurationValue === "" ? 0 : parseInt(item.configurationValue),
                minValue: parseInt(item.minValue),
                maxValue: parseInt(item.maxValue),
                userID: parseInt(tokenService.getUserIDFromToken()),
            };
        }).filter(item => item.divisionID && item.divisionID !== 0);

        const uniqueDetail = detail.filter((item, index, self) =>
            index === self.findIndex(t =>
                t.estateID === item.estateID &&
                t.divisionID === item.divisionID &&
                t.fromDate === item.fromDate
            )
        );

        const response = await services.NormValuesSave(uniqueDetail);

        if (response.statusCode === "Success") {
            props.history.push({
                pathname: '/NormAssignEdit',
                state: {
                    savedStatus: response.statusCode,
                    savedMessage: response.message
                }
            });
            return;
        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        setNormDetails([]);
        setSelectedDivision([]);
        setSelectedEstates([]);
        setIsEnable(true);
        setIsTableHidden(true);
        setNormValue({
            ...normValue,
            estate: [],
            divisionID: [],
            configurationID: '0',
            configurationValue: '',
            minValue: '',
            maxValue: ''
        });
    }

    async function handleAllDataSave(e) {
        e.preventDefault();
        await handleSave();
    }

    function handleDeleteRow(rowIndex) {
        const updatedNormDetails = normDetails.filter((_, index) => index !== rowIndex);
        setNormDetails(updatedNormDetails);

        if (updatedNormDetails.length === 0) {
            setIsEnable(true);
            setIsTableHidden(true);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function getPermissions() {
        try {
            const permissions = await authService.getPermissionsByScreen(screenCode);
            const isAuthorized = permissions.find(p => p.permissionCode === 'ADDNORMASSIGN');
            if (!isAuthorized) {
                props.history.push('/unauthorized');
                return;
            }

            const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
            const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

            setPermissions({
                isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
                isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            });

            const token = tokenService.getUserDetailsFromTokenV2();
            let estateArray = {};
            if (token.operationEntities && token.operationEntities.length > 0) {
                token.operationEntities.forEach(item => {
                    estateArray[item.OperationEntityID] = item.OperationEntityName;
                });
            }
            setMultipleEstates(estateArray);

            setNormValue(prevState => ({
                ...prevState,
                groupID: token.groupID || '0',
                estate: token.operationEntityID || '0'
            }));

            await getAllGroups();
        } catch (error) {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: "Failed to load permissions or token data."
            });
        }
    }


    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        try {
            const apiEstates = await services.getEstatesByGroupID(normValue.groupID);
            const apiEstatesObject = {};
            apiEstates.forEach((name, index) => {
                if (name !== null && name !== undefined) {
                    apiEstatesObject[String(index)] = name;
                }
            });

            let estatesToShow = {};
            if (Object.keys(multipleEstates).length === 0) {
                estatesToShow = apiEstatesObject;
            } else {
                estatesToShow = Object.keys(apiEstatesObject).reduce((acc, key) => {
                    if (multipleEstates[key]) {
                        acc[key] = multipleEstates[key];
                    }
                    return acc;
                }, {});
            }

            setFilteredEstates(estatesToShow);
            setEstates(apiEstatesObject);

            setSelectedEstates([]);
            setSelectedDivision([]);
            setNormValue(prevState => ({
                ...prevState,
                estate: [],
                divisionID: [],
                configurationID: '0'
            }));
            setDivisions({});
            setConfigurationName([]);
            setDivisionEstateMap({});

        } catch (error) {
            setErrors(prevErrors => ({
                ...prevErrors,
                estate: "Failed to load operation entities."
            }));
        }
    }

    async function getConfigurationNameForDropdown() {
        try {
            const firstEstateID = selectedEstates[0]?.value;
            if (!firstEstateID || firstEstateID === '0') return;

            const data = await services.getConfigurationNames(firstEstateID);
            setConfigurationName(data);
            const validKeys = Object.keys(data).filter(key => data[key]);
            const firstConfigID = validKeys[0];
            if (firstConfigID) {
                setNormValue(prevState => ({
                    ...prevState,
                    configurationID: firstConfigID
                }));
                setErrors(prevErrors => ({
                    ...prevErrors,
                    configurationID: undefined
                }));
            }
        } catch (error) {
            setErrors(prevErrors => ({
                ...prevErrors,
                configurationID: "Failed to load configuration names."
            }));
        }
    }

    async function getDivisionsForDropDown() {
        let combinedDivisions = {};
        let divEstateMap = {};
        for (const estate of selectedEstates) {
            if (estate.value && estate.value !== '0') {
                const data = await services.getDivisionByEstateID(estate.value);
                combinedDivisions = { ...combinedDivisions, ...data };
                Object.keys(data).forEach(divID => {
                    divEstateMap[divID] = estate.value;
                });
            }
        }
        setDivisions(combinedDivisions);
        setDivisionEstateMap(divEstateMap);
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    const handleEstateChange = (selectedOptions) => {
        setSelectedEstates(selectedOptions);
        setNormValue(prev => ({
            ...prev,
            estate: selectedOptions.map(option => option.value)
        }));
        setErrors(prev => ({
            ...prev,
            estate: undefined
        }));
    };

    const handleEstateSelectAll = (selectAll) => {
        if (selectAll) {
            const allOptions = Object.entries(filteredEstates).map(([value, label]) => ({ value, label }));
            setSelectedEstates(allOptions);
            setNormValue(prev => ({
                ...prev,
                estate: allOptions.map(option => option.value)
            }));
        } else {
            setSelectedEstates([]);
            setNormValue(prev => ({
                ...prev,
                estate: [],
                divisionID: []
            }));
        }
        setErrors(prev => ({
            ...prev,
            estate: undefined
        }));
    };

    const handleEstateClear = () => {
        setSelectedEstates([]);
        setSelectedDivision([]);
        setNormValue(prev => ({
            ...prev,
            estate: [],
            divisionID: []
        }));
        setErrors(prev => ({
            ...prev,
            estate: undefined
        }));
    };

    function clearButton() {
        setIsEnable(true);
        const validKeys = Object.keys(configurationName).filter(key => configurationName[key]);
        const firstConfigID = validKeys[0] || '0';
        setNormValue(prevState => ({
            ...prevState,
            groupID: normValue.groupID,
            estate: normValue.estate,
            configurationID: firstConfigID,
            divisionID: "",
            estimatedDate: '',
            configurationValue: '',
            minValue: '',
            maxValue: '',
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0]
        }));
        setErrors({});
        setNormDetails([]);
        setSelectedDivision([]);
        setIsTableHidden(true);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Add Norm Assign"
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/NormAssignEdit"
                        />
                        <form onSubmit={handleAdd}>
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                                            value={normValue.groupID}
                                            onChange={handleChange}>

                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <MultiSelect
                                            items={Object.entries(filteredEstates).map(([value, label]) => ({ value, label }))}
                                            selectedValues={selectedEstates}
                                            label="Operation Entity *"
                                            placeholder="Select Operation Entities"
                                            selectAllLabel="Select All Operation Entities"
                                            noOptionsText="No Operation Entities"
                                            limitTags={3}
                                            onToggleOption={handleEstateChange}
                                            onSelectAll={handleEstateSelectAll}
                                            onClearOptions={handleEstateClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={!isEnable || !permissionList.isOperationEntityFilterEnabled}
                                        />
                                        {errors["estate"] && <FormHelperText error>{errors["estate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">

                                        <MultiSelect
                                            items={Object.entries(divisions).map(([value, label]) => ({
                                                value,
                                                label,
                                                estateID: divisionEstateMap[value]
                                            }))}
                                            selectedValues={selectedDivisions}
                                            label="Division"
                                            placeholder="Select Divisions"
                                            selectAllLabel="Select All Divisions"
                                            noOptionsText="No Divisions"
                                            limitTags={3}
                                            onToggleOption={handleDivisionChange}
                                            onSelectAll={handleDivisionSelectAll}
                                            onClearOptions={handleDivisionClear}
                                            getOptionLabel={option => option.label}
                                            isDisabled={!isEnable}
                                        />

                                        {/* {errors["divisionID"] && <FormHelperText error>{errors["divisionID"]}</FormHelperText>} */}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="configurationID">Configuration Name *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="configurationID"
                                            id="configurationID"
                                            name="configurationID"
                                            value={normValue.configurationID}
                                            disabled={!isEnable}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Configuration Name--</MenuItem>
                                            {generateDropDownMenu(configurationName)}
                                        </Select>
                                        {errors["configurationID"] && <FormHelperText error>{errors["configurationID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={normValue.fromDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText error>{errors["fromDate"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            value={normValue.toDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputProps={{
                                                inputProps: {
                                                    min: normValue.fromDate,
                                                }
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText error>{errors["toDate"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <TextField
                                            type="text"
                                            id="minValue"
                                            name="minValue"
                                            fullWidth
                                            label="Minimum Value *"
                                            value={normValue.minValue}
                                            disabled={!isEnable}
                                            onChange={handleChange}
                                            InputProps={{
                                                inputProps: {
                                                    min: 0,
                                                    max: 999,
                                                    maxLength: 3
                                                }
                                            }}
                                        />
                                        {errors["minValue"] && <FormHelperText error>{errors["minValue"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <TextField
                                            type="text"
                                            id="maxValue"
                                            name="maxValue"
                                            fullWidth
                                            label="Maximum Value *"
                                            value={normValue.maxValue}
                                            disabled={!isEnable}
                                            onChange={handleChange}
                                            InputProps={{
                                                inputProps: {
                                                    min: 0,
                                                    max: 999,
                                                    maxLength: 3
                                                }
                                            }}
                                        />
                                        {errors["maxValue"] && <FormHelperText error>{errors["maxValue"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <label>Is Sunday Enabled</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isDefault"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isDefault"
                                                    onChange={(e) => handleSundayToggle(e)}
                                                    checked={normValue.isSundayEnabled}

                                                />
                                                <label htmlFor="isDefault" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                                {errors["isDefault"] && <FormHelperText error>{errors["isDefault"]}</FormHelperText>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="Add"
                                            disabled={!isEnable}
                                            onClick={handleAdd}
                                        />
                                    </div>
                                </div>

                                <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Collection Point</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Date</TableCell>
                                                    {/* <TableCell align="center" style={{ fontWeight: "bold" }}>Configuration Value</TableCell> */}
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Min Value</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Max Value</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {normDetails.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{row.division}</TableCell>
                                                        <TableCell align="center">{row.fromDate}</TableCell>
                                                        {/* <TableCell align="center">{row.configurationValue ? row.configurationValue : '-'}</TableCell> */}
                                                        <TableCell align="center">{row.minValue}</TableCell>
                                                        <TableCell align="center">{row.maxValue}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleDeleteRow(index)}
                                                                title="Delete"
                                                                aria-label="Delete"
                                                            >
                                                                <DeleteOutlineIcon color="secondary" fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <div className="card-footer">
                                            <input
                                                type="submit"
                                                className="btn btn-primary"
                                                value="Save"
                                                onClick={handleAllDataSave}
                                            />
                                            <input
                                                type="reset"
                                                className="btn btn-warning pull-right"
                                                value="Clear"
                                                onClick={clearButton}
                                            />
                                        </div>
                                    </TableContainer>
                                </Box>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
